// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"293":"itamat","333":"party","353":"contact","389":"404","539":"misc"}[chunkId] + "." + {"293":"4eda0961","333":"5bdbf2ba","353":"b742b088","389":"a31b20f1","539":"0faece64"}[chunkId] + ".css";
};